/* ==========================================================================
   Solzaleben, cart drawer (aanvulling op Hyper cart.js).

   - "Das brauchst du noch": [data-solza-cart-add] voegt de ondervloer toe via
     /cart/add.js en ververst de drawer met het Hyper-event cart:refresh.
     GA4: add_to_cart (gtag, anders dataLayer). De bestaande events blijven.
   - Versand: staat er iets anders dan vloeren of stalen in de winkelwagen,
     dan halen we het tarief op dat de checkout rekent (shipping rates voor
     Duitsland; DE heeft één zone, dus de postcode doet niet ter zake).
     Lukt dat niet, dan blijft de tekst "wird an der Kasse berechnet".
   - Bid & Buy-hint: alleen zichtbaar als de app bieden voor die vloer toestaat
     (dezelfde app-proxy als het app block). Naam = Ansprechpartner van dit
     bezoek (sessionStorage, gezet door solza-pdp-bid.js). Staat het app block
     van dat product op de pagina, dan opent solza-pdp-bid.js de popup
     (data-solza-bid-open="cart"); anders gaan we naar de PDP met #bieden.

   De drawer-inhoud wordt bij elke wijziging vervangen; daarom starten we na
   elk cart:updated-event opnieuw.
   ========================================================================== */
(function () {
  'use strict';

  if (window.SolzaCart) return;
  window.SolzaCart = true;

  var euro = function (cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  };

  /* ------------------------------------------------------------ GA4 */
  function meetToevoegen(knop) {
    var aantal = parseInt(knop.getAttribute('data-quantity'), 10) || 1;
    var prijs = parseFloat(knop.getAttribute('data-price')) || 0;
    var item = {
      item_id: knop.getAttribute('data-item-sku') || knop.getAttribute('data-variant-id'),
      item_name: knop.getAttribute('data-item-name') || '',
      item_brand: knop.getAttribute('data-item-brand') || '',
      item_list_name: 'Das brauchst du noch',
      price: prijs,
      quantity: aantal,
    };
    var data = { currency: 'EUR', value: Math.round(prijs * aantal * 100) / 100, items: [item] };
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'add_to_cart', data);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({ event: 'add_to_cart', ecommerce: data });
      }
    } catch (_fout) {
      /* meten mag toevoegen nooit blokkeren */
    }
  }

  /* --------------------------------------------- Das brauchst du noch */
  document.addEventListener('click', function (event) {
    var knop = event.target.closest && event.target.closest('[data-solza-cart-add]');
    if (!knop || knop.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    knop.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(knop.getAttribute('data-variant-id')), quantity: Number(knop.getAttribute('data-quantity')) || 1 }],
      }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        meetToevoegen(knop);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      })
      .catch(function () {
        knop.removeAttribute('aria-busy');
      });
  });

  /* ------------------------------------------------------------ Versand */
  var ADRES = 'shipping_address%5Bzip%5D=10115&shipping_address%5Bcountry%5D=Germany&shipping_address%5Bprovince%5D=';

  function wacht(ms) {
    return new Promise(function (ok) {
      setTimeout(ok, ms);
    });
  }

  function haalTarieven() {
    return fetch('/cart/prepare_shipping_rates.json?' + ADRES, { method: 'POST' }).then(function () {
      var poging = 0;
      function probeer() {
        poging += 1;
        return fetch('/cart/async_shipping_rates.json?' + ADRES).then(function (r) {
          if (r.status === 200) return r.json();
          if (poging >= 10) throw new Error('rates');
          return wacht(800).then(probeer);
        });
      }
      return probeer();
    });
  }

  function toonVersand() {
    var regel = document.querySelector('#CartDrawer [data-solza-versand]');
    if (!regel) return;
    var tekst = regel.querySelector('[data-solza-versand-tekst]');
    haalTarieven()
      .then(function (data) {
        var tarieven = (data && data.shipping_rates) || [];
        if (!tarieven.length || !tekst || !document.contains(regel)) return;
        var laagste = tarieven.reduce(function (min, t) {
          var cent = Math.round(parseFloat(t.price) * 100);
          return min === null || cent < min ? cent : min;
        }, null);
        tekst.textContent = laagste > 0 ? 'Versand: ' + euro(laagste) : 'Kostenloser Versand';
      })
      .catch(function () {
        /* tekst "wird an der Kasse berechnet" blijft staan */
      });
  }

  /* -------------------------------------------------------- Bid & Buy */
  function contactNaam() {
    try {
      return window.sessionStorage.getItem('solza-bid-contact-naam') || '';
    } catch (_fout) {
      return '';
    }
  }

  function toonBid() {
    var hint = document.querySelector('#CartDrawer [data-solza-cart-bid]');
    if (!hint) return;
    var gid = hint.getAttribute('data-product-gid');
    var naam = contactNaam();
    if (naam) {
      hint.querySelectorAll('[data-solza-contact-naam]').forEach(function (el) {
        el.textContent = naam;
      });
    }

    fetch('/apps/solza-1/bids?productId=' + encodeURIComponent(gid))
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data || !data.visible || !document.contains(hint)) return;
        var knop = hint.querySelector('[data-solza-cart-bid-open]');
        var block = document.querySelector('[data-solza-bid-block][data-product-id="' + gid + '"]');
        if (block && !block.hidden && knop) knop.setAttribute('data-solza-bid-open', 'cart');
        hint.hidden = false;
      })
      .catch(function () {
        /* geen app-antwoord: hint blijft verborgen */
      });
  }

  document.addEventListener('click', function (event) {
    var knop = event.target.closest && event.target.closest('[data-solza-cart-bid-open]');
    if (!knop) return;
    var drawer = document.getElementById('CartDrawer');
    if (knop.hasAttribute('data-solza-bid-open')) {
      // solza-pdp-bid.js opent de popup; de drawer gaat dicht zodat hij zichtbaar is.
      if (drawer && typeof drawer.hide === 'function') drawer.hide();
      return;
    }
    var hint = knop.closest('[data-solza-cart-bid]');
    if (hint) window.location.href = hint.getAttribute('data-url').split('#')[0] + '#bieden';
  });

  /* ------------------------------------------------------------ Start */
  function start() {
    try {
      toonVersand();
      toonBid();
    } catch (_fout) {
      /* drawer blijft bruikbaar */
    }
  }

  document.addEventListener('cart:updated', start);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
